import type { ReactNode, CSSProperties } from 'react'
import type { ContextualMenuItem } from '../ContextualMenu/ContextualMenu.types'

export type AlertVariant = 'critical' | 'urgent' | 'info' | 'success'

export type AlertLayout = 'board' | 'toast'

export const ALERT_VARIANTS: AlertVariant[] = [
  'critical',
  'urgent',
  'info',
  'success',
]

export const ALERT_LAYOUTS: AlertLayout[] = ['board', 'toast']

export type AlertAction = {
  label: string
  onClick?: () => void
}

export type AlertProps = {
  variant?: AlertVariant
  layout?: AlertLayout
  title: string
  timestamp?: string
  description: string
  primaryAction?: AlertAction
  secondaryAction?: AlertAction
  showActions?: boolean
  showMenu?: boolean
  menuItems?: ContextualMenuItem[]
  onMenuClick?: () => void
  /** Dark-surface appearance. */
  darkMode?: boolean
  /** Plays enter animation on mount (use when showing / revealing an alert). */
  animate?: boolean
  /**
   * Plays exit animation. Keep mounted until the animation finishes (~300ms),
   * matching common NotificationToast dismiss behavior.
   */
  exiting?: boolean
  className?: string
  style?: CSSProperties
  icon?: ReactNode
}
